export enum ClockInRequirement {
  MatchingShift = 1,
  AnyShift = 2,
  NoShift = 3,
}
